module.exports = __webpack_public_path__ + "static/media/bannerTablet@1x.ed990e25.jpg";